import React from 'react';
import styled from 'styled-components';

const StyledGradientSection = styled.div`
  flex-direction: column;
  align-items: flex-start;
  font-weight: 500;
  width: 100%;

  /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#0f62bd+0,0c519d+100 */
  background: #0f62bd; /* Old browsers */
  background: -moz-linear-gradient(-45deg, #0f62bd 0%, #0c519d 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(-45deg, #0f62bd 0%,#0c519d 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(135deg, #0f62bd 0%,#0c519d 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#0f62bd', endColorstr='#0c519d',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
    
  @media (max-width: 600px) {
  } 
  @media (max-width: 480px) {
  }
`;


const GradientSection = (props) => (<StyledGradientSection>{props.children}</StyledGradientSection>);

export default GradientSection;


// WEBPACK FOOTER //
// ./src/Components/GradientSection.js